import { render, staticRenderFns } from "./WinnerPrizeStatus.vue?vue&type=template&id=4cc85cf2&scoped=true"
import script from "./WinnerPrizeStatus.vue?vue&type=script&lang=js"
export * from "./WinnerPrizeStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc85cf2",
  null
  
)

export default component.exports